// extracted by mini-css-extract-plugin
var _1 = "Widget-moduleWidget__bcnWB";
export { _1 as "Widget" }
